import React, { useState, useEffect } from "react";
import { Button, Card, Col, Form, Modal, Row, Tooltip } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import ApiBasketItemPerson from "../../../../core/api/api.basketItemPerson";
import { useForm } from "react-hook-form";
// import { ArrowRightShort } from "react-bootstrap-icons";
// import ReactTooltip from 'react-tooltip';
import _ from "lodash";
import { IconArrowRight, IconInfo } from "../../../../assets/icons";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import LoadingDottedButton from "../../../components/LoadingDottedButton";

function ModalCanclepersonItem(props) {
  console.log("ppr=",props);
  const [show, setShow] = useState(true);
  const [checkBoxList, setCheckBoxList] = useState([]);
  const [Describ, setDescrib] = useState("");
  const [reasonCancel, setReasonCancle] = useState(0);
  const [somethingWrong, setSomethingWrong] = useState({
    wrongSelect: 0,
    wrongDescrib: 0,
    wrongReason: 0,
  });
  const [reasonListApi, setReasonListApi] = useState([]);
    const {
        register,
        handleSubmit,
        control,
        formState: { errors, isSubmitting },
        getValues,
        setValue,
    } = useForm();

  useEffect(() => {
    (async () => {
      const result = await ApiBasketItemPerson.getBasketCancelType();
      setReasonListApi(result.data);
    })();
  }, []);

  // --------------------------------بستن مودال ------------------------------------------------------
  const handleClose = () => {
    setShow(!show);
    props.callBack();
  };
  // ----------------افزودن  یا حذف  افراد به لیست افراد کنسلی     --------------------------------
  const handleSelect = (id) => {
    const data = { id: id };
    setSomethingWrong((prevSomethingWrong) => ({
      ...prevSomethingWrong,
      wrongSelect: 0,
    }));
    checkBoxList.some((item) => id === item)
      ? setCheckBoxList((checkBoxList) =>
          checkBoxList.filter((item) => item != id)
        )
      : setCheckBoxList((checkBoxList) => [...checkBoxList, id]);
  };

  // ------------------دریافت مقدار وارد شده در اینپوت توضیحات -------------------------------------
  const getInputValueDescription = (event) => {
    const desValue = event.target.value;
    setDescrib(desValue);
    setSomethingWrong((prevSomethingWrong) => ({
      ...prevSomethingWrong,
      wrongDescrib: 0,
    }));
  };
  // ------------------مرحله ی نهایی و چک کردن ارور های احتمالی -------------------------------------
  const onSubmit = async (data) => {
    if (
      reasonCancel === 0 ||
      Describ.length === 0 ||
      checkBoxList.length === 0
    ) {
      if (reasonCancel === 0) {
        // toast.configure();
        toast.error("دلیل کنسلی مشخص نشده است !  ", { position: "top-right" });
        setSomethingWrong((prevSomethingWrong) => ({
          ...prevSomethingWrong,
          wrongReason: 1,
        }));
      } else if (Describ.length === 0) {
        // toast.configure();
        toast.error("توضیحات وارد نشده است ! ", { position: "top-right" });

        setSomethingWrong((prevSomethingWrong) => ({
          ...prevSomethingWrong,
          wrongDescrib: 1,
        }));
      } else if (checkBoxList.length === 0) {
        // toast.configure();
        toast.error(" هنوز فردی انتخاب نشده است !", { position: "top-right" });
        setSomethingWrong((prevSomethingWrong) => ({
          ...prevSomethingWrong,
          wrongSelect: 1,
        }));
      }
    } else {
      const dataToSendForCancle = {
        basketId: props.basket.id,
        basketItemId: props.item.id,
        cancelType: reasonCancel,
        description: Describ,
        basketItemPersonList: checkBoxList,
      };

      const respons = await ApiBasketItemPerson.cancleBasketItemPerson(
        dataToSendForCancle
      );

      // toast.configure();
      toast(respons.message, { position: "top-right" });
      respons.succeeded && handleClose();
    }
  };
  // -----------------------------------------انتخاب دلیل کنسل کردن -------------------------------------
  const handleSelecetReason = (status) => {
    setReasonCancle(status);
    setSomethingWrong((prevSomethingWrong) => ({
      ...prevSomethingWrong,
      wrongReason: 0,
    }));
  };
  //---------------------------------------------------------------------------------------------------------
  const handleErrorDisabld = (name) => {
    // toast.configure();
    toast("قبلا درخواست کنسلی برای " + name + " " + "ثبت شده است.", {
      position: "top-right",
    });
  };

  return (
    <>
      {/* <ToastContainer rtl="true" position="top-right"></ToastContainer> */}
      {/* <Zoom triggerOnce={true} > */}
      <Modal
        show={show}
        size="md"
        fullscreen="md-down"
        centered
        onHide={handleClose}
        className="pt-0"
        scrollable
      >
        <Modal.Header className="pb-2">
          <Modal.Title>
            <h6 className="fw-bold my-0 py-0" onClick={handleClose}>
              <IconArrowRight fillColor="#000" />
              درخواست کنسلی{" "}
              <span className=" fw-bold">
                {props.item.amusementServiceName}
              </span>
            </h6>
            <div className="fs-07 mt-2 text-black-06">
              جهت ثبت درخواست کنسلی، لطفا فرم زیر را تکمیل کنید.
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="my-0 pt-3 px-2 px-md-3 mb-5">
          <Form onSubmit={handleSubmit(onSubmit)}>
            {props.item.basketItemPersons.length >= 1 ? (
              <>
                {/* // --------------------------------------------------------------------------------------- */}
                {/* //    مودال برای ثبت دلیل      */}
                <Card className="bg-light">
                  <Card.Body>
                    <Row className="my-0 py-0">
                      <Col xs="12" className="px-1 fw-bold mb-2 fs-085">
                        <span
                          className={
                            somethingWrong.wrongReason === 1
                              ? "text-danger"
                              : ""
                          }
                        >
                          1. علت کنسلی شما چیست ؟
                        </span>
                      </Col>
                    </Row>
                    <Row className="d-flex justify-content-between ">
                      {reasonListApi.map((item, index) => (
                        <Col
                          xs="6"
                          className="my-1 px-1 "
                          key={index}
                          onClick={() =>
                            handleSelecetReason(parseInt(item.value))
                          }
                        >
                          <div
                            className={
                              reasonCancel === parseInt(item.value)
                                ? " py-2  d-flex justify-content-center px-0 fs-07  rounded-2 border border-primary text-primary bg-white cursor-pointer"
                                : " py-2  d-flex justify-content-center rounded-2  fs-07 border text-muted px-0 bg-white cursor-pointer"
                            }
                          >
                            {item.title}
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </Card.Body>
                </Card>
                {/* -------------------------------------------------------------------------------------------- */}

                {/* ثبت توضیحات  */}
                <Card className="mt-3 bg-light">
                  <Card.Body>
                    <Row className=" px-0">
                      <Col xs="12" className=" px-1">
                        <Form.Group>
                          <Form.Label className=" my-auto  w-100  ">
                            <div className="text-dark fw-bold mb-2">
                              <span
                                className={
                                  somethingWrong.wrongDescrib === 1
                                    ? "text-danger"
                                    : ""
                                }
                              >
                                2. درج توضیحات
                              </span>
                            </div>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            className="py-3 my-0  rounded-2 fs-08"
                            placeholder="متن توضیحات"
                            onChange={getInputValueDescription}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
                {/* //-----------------------------------------------------------------------------------  */}
                {/* //  نمایش لیستی از افراد وابسته به سفارش برای انتخاب  */}
                <Card className="mt-3 bg-light pb-1">
                  <Card.Body>
                    <Row className="px-0">
                      <Col xs="auto" className="px-1 fw-bold">
                        <div
                          className={
                            somethingWrong.wrongSelect === 1
                              ? "text-danger fw-bold "
                              : "fw-bold text-dark"
                          }
                          style={{ fontSize: "15px" }}
                        >
                          3. انتخاب افراد
                        </div>
                        <div className="fs-07 text-black-06">
                          جهت کنسل کردن بلیط ، نام افراد موردنظر را انتخاب
                          نمایید تا کنسلی فقط برای این افراد ثبت گردد.
                        </div>
                      </Col>
                    </Row>
                    <Row className="pb-2 mt-3">
                      <Col className="my-auto fw-bold text-muted fs-07 pe-0">
                        نام و نام خانوادگی
                      </Col>
                      <Col
                        xs="3"
                        className="my-auto fw-bold text-muted fs-07 text-center"
                      >
                        وضعیت
                      </Col>
                    </Row>
                    <hr className="my-0 py-0 bg-muted" />

                    {props.item.basketItemPersons.map((person, index) => (
                      <Row className=" mt-1 ps-1" key={index}>
                        {(person.cancelStatus === 0) |
                        (person.cancelStatus === 5) ? (
                          <Col
                            xs="auto"
                            className="ps-0 pe-0 cursor-pointer  my-auto"
                          >
                            <input
                              id={`id-${index}`}
                              type="checkbox"
                              className=" cursor-pointer option-input input-option-sm rounded-1 mt-2"
                              onChange={() => handleSelect(person.id)}
                              checked={checkBoxList.some(
                                (item) => person.id === item
                              )}
                            />
                          </Col>
                        ) : (
                          <Col
                            xs="auto"
                            className="pe-0 ps-0  cursor-pointer my-auto"
                            onClick={() =>
                              handleErrorDisabld(
                                person.personFullName
                              )
                            }
                          >
                            <input
                              type="checkbox"
                              className="  cursor-pointer option-input input-option-sm rounded-1 mt-2"
                              checked={false}
                              readOnly
                            />
                          </Col>
                        )}

                        <Col>
                          <Row className="">
                            <Col className=" ps-0 mt-1">
                              <label
                                className=" text-dark d-inline-block cursor-pointer"
                                for={`id-${index}`}
                              >
                                {person.personFullName}
                              </label>{" "}
                            </Col>
                            <Col xs="auto" className=" mt-1 px-0">
                              {person.cancelStatus !== 0 &&
                              person.cancelStatus !== 5 ? (
                                <div
                                  className={
                                    person.cancelStatus === 1
                                      ? " text-success  fs-075 "
                                      : "text-danger fs-075 "
                                  }
                                >
                                  <div> {person.cancelStatusS}</div>
                                </div>
                              ) : (
                                <div className="fs-075 text-primary  ">
                                  فعال
                                </div>
                              )}
                            </Col>
                            <Col
                              xs="auto"
                              className=" ps-0"
                              style={{ marginTop: "2px" }}
                            >
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip id={"log" + person.id}>
                                    {!_.isEmpty(person.lastBasketItemPersonLog)
                                      ? "توضیحات اپراتور: " +
                                        person.lastBasketItemPersonLog
                                      : "توضیحی ثبت نشده است"}
                                  </Tooltip>
                                }
                              >
                                <span
                                  className="ms-1"
                                  data-tip
                                  data-for={"log" + person.id}
                                >
                                  <IconInfo fillColor="#002270" />
                                </span>
                              </OverlayTrigger>
                              {/* {<ReactTooltip id={"log" + person.id} place="top" effect="float" type="info" clickable={true}>
                                                            {!_.isEmpty(person.lastBasketItemPersonLog) ? "توضیحات اپراتور: " + person.lastBasketItemPersonLog : "توضیحی ثبت نشده است"}
                                                        </ReactTooltip> */}
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    ))}
                  </Card.Body>
                </Card>
                {/* ------------------------------------------------------------------------------------------------- */}
                {/* دکمه ای انصراف و ثبت نهایی */}
              </>
            ) : (
              <small className="text-danger">
                هنوز فردی برای این ایتم مشخص نشده است !
              </small>
            )}
            <Row className="mt-3 pb-3">
              <Col xs="7" className="pe-0">
                {!isSubmitting ? (
                  <button
                    type="submit"
                    className="btn btn-primary fs-9 px-3 w-100"
                  >
                    ثبت نهایی
                  </button>
                ) : (
                  <button
                    disabled
                    type="submit"
                    className="btn btn-primary fs-9 px-3 w-100"
                  >
                    <LoadingDottedButton btnText="ثبت نهایی" />
                  </button>
                )}

                {/* <Button
                  variant="primary"
                  className="fs-9 w-100"
                  type="submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting && (
                    <Spinner animation="border" variant="warning" size="sm" />
                  )}
                  {isSubmitting ? (
                    <span className="ms-2">ثبت نهایی</span>
                  ) : (
                    <div className="px-3 ">ثبت نهایی</div>
                  )}
                </Button> */}
              </Col>
              <Col xs="5">
                <Button
                  onClick={handleClose}
                  variant="outline-primary"
                  className="fs-9 w-100"
                >
                  انصراف
                </Button>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ModalCanclepersonItem;
